(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dolce-pack-selector-48"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dolce-pack-selector-48')) {
  customElements.define('dolce-pack-selector-48', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-pack-submit]');
      this.buttonText = this.querySelector('[data-pack-button-text]');
      this.error = this.querySelector('.dpk-error');
      this.page = this.closest('.lp48');
      this.page?.querySelectorAll('[data-lp48-add]').forEach(button => button.addEventListener('click', () => this.button.click()));
      this.form.addEventListener('change', () => this.updateSelection());
      this.form.addEventListener('submit', event => this.addPack(event));
      this.updateSelection();
    }
    updateSelection() {
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected) return;
      this.querySelector('[data-pack-count]').textContent = selected.dataset.quantity;
      this.querySelector('[data-pack-price]').textContent = selected.dataset.price;
      this.querySelector('[data-pack-saving]').textContent = selected.dataset.saving;
      this.button.disabled = selected.disabled;
      this.buttonText.textContent = selected.disabled ? this.dataset.soldOut : this.dataset.add;
      const price = this.page?.querySelector('[data-pack-sticky-price]');
      const label = this.page?.querySelector('[data-pack-sticky-label]');
      const sticky = this.page?.querySelector('[data-lp48-sticky] [data-lp48-add]');
      if (price) price.textContent = selected.dataset.price;
      if (label) label.textContent = selected.dataset.quantity + ' MINI';
      if (sticky) sticky.disabled = selected.disabled;
      this.error.hidden = true;
    }
    async addPack(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected || selected.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.buttonText.textContent = this.dataset.adding;
      this.error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(selected.value),quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(root + 'cart');
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.button.disabled = false;
        this.buttonText.textContent = this.dataset.add;
        this.busy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dolce-pack-selector-60"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dolce-pack-selector-60')) {
  customElements.define('dolce-pack-selector-60', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-pack-submit]');
      this.buttonText = this.querySelector('[data-pack-button-text]');
      this.error = this.querySelector('.dpk-error');
      this.page = this.closest('.d60-product');
      this.page?.querySelectorAll('[data-d60-sticky-add], [data-d60-final-add]').forEach(button => button.addEventListener('click', () => this.button.click()));
      this.form.addEventListener('change', () => this.updateSelection());
      this.form.addEventListener('submit', event => this.addPack(event));
      this.updateSelection();
    }
    updateSelection() {
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected) return;
      this.querySelector('[data-pack-count]').textContent = selected.dataset.quantity;
      this.querySelector('[data-pack-price]').textContent = selected.dataset.price;
      this.querySelector('[data-pack-saving]').textContent = selected.dataset.saving;
      this.button.disabled = selected.disabled;
      this.buttonText.textContent = selected.disabled ? this.dataset.soldOut : this.dataset.add;
      const price = this.page?.querySelector('.d60-sticky strong');
      const label = this.page?.querySelector('.d60-sticky small');
      const sticky = this.page?.querySelector('[data-d60-sticky-add]');
      if (price) price.textContent = selected.dataset.price;
      if (label) label.textContent = selected.dataset.quantity + ' MINI';
      this.page?.querySelectorAll('[data-d60-sticky-add], [data-d60-final-add]').forEach(button => { button.disabled = selected.disabled; button.textContent = 'AGREGAR ' + selected.dataset.quantity + ' MINI'; });
      const finalPrice = this.page?.querySelector('[data-pack-final-price]');
      const finalLabel = this.page?.querySelector('[data-pack-final-label]');
      if (finalPrice) finalPrice.textContent = selected.dataset.price;
      if (finalLabel) finalLabel.textContent = 'Tu selección: ' + selected.dataset.quantity + ' mini';
      this.error.hidden = true;
    }
    async addPack(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected || selected.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.buttonText.textContent = this.dataset.adding;
      this.error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(selected.value),quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(root + 'cart');
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.button.disabled = false;
        this.buttonText.textContent = this.dataset.add;
        this.busy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dolce-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dolce-pack-selector')) {
  customElements.define('dolce-pack-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-pack-submit]');
      this.buttonText = this.querySelector('[data-pack-button-text]');
      this.error = this.querySelector('.dpk-error');
      this.page = this.closest('.dbp-product-page');
      this.form.addEventListener('change', () => this.updateSelection());
      this.form.addEventListener('submit', event => this.addPack(event));
      this.updateSelection();
    }
    updateSelection() {
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected) return;
      this.querySelector('[data-pack-count]').textContent = selected.dataset.quantity;
      this.querySelector('[data-pack-price]').textContent = selected.dataset.price;
      this.querySelector('[data-pack-saving]').textContent = selected.dataset.saving;
      this.button.disabled = selected.disabled;
      this.buttonText.textContent = selected.disabled ? this.dataset.soldOut : this.dataset.add;
      const price = this.page?.querySelector('[data-pack-sticky-price]');
      const label = this.page?.querySelector('[data-pack-sticky-label]');
      const sticky = this.page?.querySelector('[data-dbp-sticky-add]');
      if (price) price.textContent = selected.dataset.price;
      if (label) label.textContent = selected.dataset.quantity + ' MINI';
      if (sticky) sticky.disabled = selected.disabled;
      this.error.hidden = true;
    }
    async addPack(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (!selected || selected.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.buttonText.textContent = this.dataset.adding;
      this.error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(selected.value),quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(root + 'cart');
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.button.disabled = false;
        this.buttonText.textContent = this.dataset.add;
        this.busy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
